import script from "./GpDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./GpDetails.vue?vue&type=script&lang=ts&setup=true"

import "./GpDetails.vue?vue&type=style&index=0&id=39fc6c00&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39fc6c00"]])

export default __exports__